// M004-F0747 design sections 8 and 8.0: the claim status banner above the grid. Submitted / approved / reimbursed: the state, the
// envelope is locked, and the TX id chip that opens the SHARED transaction history drawer (ONE history method). Returned (or
// rejected): the reviewer's reason in words, and for a return "Edit and resubmit". Nothing here approves or returns anything.
import React from 'react';
import TxChip from '../TxChip';

export default function ClaimBanner({ banner, orgName, loading, loadError, onRetry, onEditResubmit, offline }) {
  if (!banner) return null;
  return (
    <section
      className={`ew-claim-banner ew-claim-banner-${banner.tone}`}
      aria-label="Claim status"
      data-testid="claim-banner"
      data-claim-state={banner.state}
      data-attention={banner.attention ? 'true' : undefined}
    >
      <div className="ew-claim-banner-head">
        <strong data-testid="claim-banner-title">{banner.title}</strong>
        {orgName ? <span className="ew-muted" data-testid="claim-banner-org">to {orgName}</span> : null}
        {banner.transactionId ? <span data-testid="claim-banner-tx"><TxChip txnId={banner.transactionId} orgId={banner.orgId} /></span> : null}
      </div>
      <p data-testid="claim-banner-text">{banner.text}</p>
      {banner.needsReason ? (
        <div className="ew-claim-reason" data-testid="claim-banner-reason-block">
          {loading ? <p className="ew-muted" role="status">Loading the reviewer&apos;s reason…</p> : null}
          {loadError ? (
            <div className="ew-error" role="alert" data-testid="claim-banner-reason-error">
              <p>{loadError.message}</p>
              {loadError.code ? <p>Error code: <code data-testid="claim-banner-reason-error-code">{loadError.code}</code></p> : null}
              <button type="button" className="ew-btn" data-testid="claim-banner-retry" onClick={onRetry}>Try again</button>
            </div>
          ) : null}
          {banner.reason ? <p><span className="ew-claim-reason-label">Reviewer&apos;s reason:</span> <q data-testid="claim-banner-reason">{banner.reason}</q></p> : null}
        </div>
      ) : null}
      {banner.canResubmit ? (
        <button type="button" className="ew-btn ew-btn-primary" data-testid="claim-banner-edit" disabled={offline} onClick={onEditResubmit}>Edit and resubmit</button>
      ) : null}
    </section>
  );
}
